import React from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { ResponsiveImage } from '@edx/graphql/generated';
import { useAuth } from '@edx/hooks/use-auth';
import { RegisterForm } from '@edx/components/register-form';

type Props = {
  bgImage: ResponsiveImage;
};

const RegisterPage: NextPage<Props> = ({ bgImage }) => {
  const router = useRouter();
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    router.push('/tablero');
  }

  return (
    <>
      <Head>
        <title key="title">Regístrate ahora</title>

        <meta name="robots" content="noindex" />
      </Head>

      <section>
        <div className="object-cover h-28">
          <picture className="blend-lighten">
            <source media="(min-width: 1122px)" srcSet={bgImage.large} />
            <source media="(min-width: 641px)" srcSet={bgImage.medium} />
            <img src={bgImage.small} alt="" className="w-full" />
          </picture>
        </div>

        <div className="max-w-6xl mx-auto px-2 md:px-4 py-1 md:py-4 mb-10">
          <h1 className="pb-20 md:pb-32 text-3xl md:text-5xl uppercase text-center font-display text-gray-300">
            Regístrate ahora
          </h1>

          <div className="grid grid-cols-12 gap-4">
            <div className="col-start-1 md:col-start-2 lg:col-start-3 col-span-12 md:col-span-10 lg:col-span-8 bg-white rounded font-body text-gray-700">
              <div className="border-b border-gray-400">
                <ul className="p-4 pb-0 flex justify-center font-medium">
                  <li className="pb-3 p-1 border-b-2 border-primary-500">1. Registro</li>
                  <li className="pb-3 p-1 text-gray-400">2. Suscripción</li>
                </ul>
              </div>

              <RegisterForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RegisterPage;
